export const EXTEND_SHORT_DESCRIPTION: { [key: string]: string } = {
	short_description: "Kurzbeschreibung/Button-Titel",
};
